import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../util/apiClient";
import CommonAlert from '../../Common/CommonAlert';
import MyDialogComponent from "../../Common/MyDialogComponent";
import { addFonctionnalites, editFonctionnalite, setDescriptionEdit, setObjFonctionnalite, setOpenDialogFonctionnalite, setValueEdit } from "./fonctionnaliteSlice";
import FormulaireFonctionnalite from "./Formulaire";
import EditFormulaireFonctionnalite from "./EditFormulaireFonctionnalite";




const AddFonctionnalite = () => {

    //redux
    const dispatch = useDispatch()
    const { objGroupeFonctionnalite } = useSelector((state: IReduxState) => state.groupeFonctionnalite);
    const { openDialogFonctionnalite, objFonctionnalite, valueEdit,descriptionEdit } = useSelector((state: IReduxState) => state.fonctionnalite);


    //hooks
    const [valueF, setValueF] = useState("");
    const [description, setDescription] = useState("");
    const [openAlert, setOpenAlert] = useState(false);


    const handleSave = async () => {
        try {
            const apiPayload = {
                idGroupeFonctionnalite: objGroupeFonctionnalite.idGroupeFonctionnalite,
                libelleFonctionnalite: valueF,
                descriptionFonctionnalite: description
            }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/creerfonctionnalite", apiPayload)
            if (res.status === 1) {
                const newF = { ...res.data, id: res.data.idFonctionnalite, libelle: res.data.libelleFonctionnalite }
                dispatch(addFonctionnalites(newF))
                // dispatch(setFilterFonctionnalites(false));
                setValueF("")
                setDescription("")
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddFonctionnalite.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    }


    const editItem = async () => {
        try {
            const apiPayload = { idFonctionnalite: objFonctionnalite.idFonctionnalite, libelleFonctionnalite: valueEdit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifierfonctionnalite", apiPayload)
            if (res.status === 1) {
                const newF = { ...res.data, id: res.data.idFonctionnalite, libelle: res.data.libelleFonctionnalite }
                dispatch(editFonctionnalite(newF))
                dispatch(setOpenDialogFonctionnalite(false));
                setValueF("")
                setDescription("")
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };

    const handleOpen = () => {
        //verifier si un module a été selectionné avant d'ouvir le dialog d'enreegistrement du sous module
        if (Object.keys(objGroupeFonctionnalite).length > 0) {
            dispatch(setObjFonctionnalite(true));
            dispatch(setOpenDialogFonctionnalite({}));
            setValueF("")
            setDescription("")
        } else {
            setOpenAlert(true)
        }
    };

    const handleClose = () => {
        dispatch(setOpenDialogFonctionnalite(false));
    };

    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    return (
        <div>
            <MyDialogComponent
                // dialogTitle={`${Object.keys(objFonctionnalite).length > 0 ? "Modifier" + " " + objFonctionnalite.libelleFonctionnalite : "Créer une fonctionnalite"}`}
               
                dialogTitle={`${
                    Object.keys(objFonctionnalite).length > 0
                      ? `Modifier ${objFonctionnalite.libelleFonctionnalite}`
                      : `Créer une fonctionnalite`
                  }`}

                dialogContent={
                    Object.keys(objFonctionnalite).length > 0
                        ? <EditFormulaireFonctionnalite
                         setValueEdit={setValueEdit}
                          valueEdit={valueEdit}
                          descriptionEdit={descriptionEdit}
                          setDescriptionEdit={setDescriptionEdit}
                          />
                        : <FormulaireFonctionnalite
                            setValueF={setValueF}
                            valueF={valueF}
                            description={description}
                            setDescription={setDescription}
                        />}
                handleSave={
                    Object.keys(objFonctionnalite).length > 0
                        ? editItem
                        : handleSave
                }
                openDialog={openDialogFonctionnalite}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />
            <CommonAlert
                severity="warning"
                variant="filled"
                description="Veuillez selectionner un groupe de fonctionnalité."
                title="Alerte !"
                openAlert={openAlert}
                handleAlertClose={handleAlertClose}
            />
        </div>
    );
}

export default AddFonctionnalite;
